import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import { analyticsTrack } from '../../../analyticsUtils';
import './PhoneNumberInput.scss';
var PhoneNumberInput = /*#__PURE__*/function (_Component) {
  function PhoneNumberInput(props) {
    var _this;
    _classCallCheck(this, PhoneNumberInput);
    _this = _callSuper(this, PhoneNumberInput, [props]);
    _this.state = {
      phone: props.defaultValue
    };
    _this.handlePhoneNumberChange = _this.handlePhoneNumberChange.bind(_this);
    _this.handleUserOptInChange = _this.handleUserOptInChange.bind(_this);
    _this.startEnteringPhone = false;
    _this.userOptedInState = props.userOptedIn;
    return _this;
  }
  _inherits(PhoneNumberInput, _Component);
  return _createClass(PhoneNumberInput, [{
    key: "handlePhoneNumberChange",
    value: function handlePhoneNumberChange(value) {
      if (value === '') {
        this.setState({
          phone: null
        });
      }
      if (!this.startEnteringPhone) {
        this.startEnteringPhone = true;
        var _location = this.props.location;
        if (_location) {
          analyticsTrack('Phone Number Input', {
            location: _location
          });
        }
      }
    }
  }, {
    key: "handleUserOptInChange",
    value: function handleUserOptInChange() {
      this.userOptedInState = !this.userOptedInState;
      analyticsTrack('Opt In/Opt Out', {
        location: location,
        state: this.userOptedInState ? 'Checked' : 'Unchecked'
      });
    }
  }, {
    key: "renderOptInCheckbox",
    value: function renderOptInCheckbox() {
      var userOptedIn = this.props.userOptedIn;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[opt_in]",
        value: "false"
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "opt-in-input"
      }, /*#__PURE__*/React.createElement("input", {
        id: "opt-in-input",
        name: "user[opt_in]",
        type: "checkbox",
        className: "mr-8",
        defaultChecked: userOptedIn,
        value: "true",
        onChange: this.handleUserOptInChange
      }), "I confirm that I want to receive SMS messages for critical hiring notifications. Message & data rates apply."));
    }
  }, {
    key: "renderCopy",
    value: function renderCopy() {
      var cloraPhone = this.props.cloraPhone;
      return /*#__PURE__*/React.createElement("span", {
        className: "body-text-3"
      }, "Our records indicate that you have opted out of SMS notifications. To resume, please text", ' ', /*#__PURE__*/React.createElement("strong", null, "START"), ' ', "to", ' ', /*#__PURE__*/React.createElement("strong", null, cloraPhone), ". Msg & data rates apply.");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        className = _this$props.className,
        renderCheckbox = _this$props.renderCheckbox;
      var phone = this.state.phone;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("div", null, "Phone number (optional)\xA0", /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "right",
        delay: {
          show: 100
        },
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "phone-number-tooltip"
        }, "We will use this information to notify you about candidates, interviews, timesheets, and other critical hiring communications.")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-info-circle"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PhoneInput, {
        value: phone,
        country: "us",
        preferredCountries: ['us'],
        containerClass: "phone-number-container",
        inputClass: "phone-number-input",
        inputProps: {
          name: 'user[phoneNumber]'
        },
        onChange: this.handlePhoneNumberChange,
        countryCodeEditable: false
      })), /*#__PURE__*/React.createElement("div", {
        className: "mt-16"
      }, renderCheckbox ? this.renderOptInCheckbox() : this.renderCopy())));
    }
  }]);
}(Component);
PhoneNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  userOptedIn: PropTypes.bool,
  location: PropTypes.string,
  renderCheckbox: PropTypes.bool.isRequired,
  cloraPhone: PropTypes.string
};
PhoneNumberInput.defaultProps = {
  className: '',
  defaultValue: '',
  userOptedIn: false,
  location: 'Location Not Specified',
  cloraPhone: ''
};
export default PhoneNumberInput;